import { render, staticRenderFns } from "./DashboardMarket.vue?vue&type=template&id=22fda7dc&"
import script from "./DashboardMarket.vue?vue&type=script&lang=ts&"
export * from "./DashboardMarket.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardMarket.vue?vue&type=style&index=0&id=22fda7dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports